export const getFormat = (isMsgPack) => isMsgPack ? "msgpack" : "json";
//# sourceMappingURL=getFormat.js.map